import { defineStore } from 'pinia';
import Configuration from '@/models/configuration.model';
import OnboardingService from '@/services/api/onboarding.service';
import CookieService from '@/services/cookie.service';
import DashService from '@/services/api/dash.service';
import TradierService from '@/services/api/tradier.service';

export const useRootStore = defineStore('root', {
  state: () => {
    const configuration = new Configuration(import.meta.env.MODE);
    const cookieService = new CookieService(configuration.cookieNames, configuration.cookieOptions);

    return {
      configuration,
      cookieService,

      onboardingService: null,
      dashService: null,
      tradierService: null,
    };
  },

  actions: {
    setupUserServices(jwt) {
      this.onboardingService = new OnboardingService(jwt, this.configuration.backendOnboardingUrl);
      this.dashService = new DashService(jwt, this.configuration.backendUrl);
    },

    setupTradierServices(accessToken) {
      this.tradierService = new TradierService(accessToken);
    },
  },
});
